module.exports = __webpack_public_path__ + "img/foto_ozuv-1.4b4fdc0e.png";